import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Store } from "../../../../../services/store.service";
import { ResizeEvent } from "angular-resizable-element";
import { BaseError } from "../../../base-error";
import { ToastrService } from "ngx-toastr";
import { RecoverOrphanConfig } from "../../../../../models/recover-orphan-config";
import { ServiceControllerService } from "../../../../../services/service-controller/service-controller.service";

@Component({
  selector: "form-description",
  templateUrl: "./form-description.component.html",
  styleUrls: [],
  providers: [],
})

export class FormDescriptionComponent extends BaseError implements OnInit {

  public serviceId: string;
  public listToggle: boolean = false;
  public activeTab: string = "general";
  @Input() public form: any;
  @Input() public determinantMapById: { [key: string]: string };
  @Output() public saveForm = new EventEmitter();
  public tempShortname: string;
  public showDeterminant: boolean = false;
  public showDrawerHeader: boolean = true;
  public tempDet: any;
  public debugErrors: RecoverOrphanConfig[] = [];

  public resizeEdges = { bottom: false, right: false, top: false, left: true };
  public style: object = {};

  constructor(private route: ActivatedRoute,
    public store: Store,
    public toastr: ToastrService,
    private serviceControllerService: ServiceControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.checkDebugMode();
  }

  public checkDebugMode() {
    this.store.debugMode$.subscribe((mode) => {
      if (mode) {
        this.fetchDebugErrors();
      } else {
        this.debugErrors = [];
      }
    });
    this.store.dryRunRefresh$.subscribe(() => {
      if (!this.store.state.common.debugMode) { return; }
      // Silent refresh: only re-render when the error list actually changed.
      this.serviceControllerService.recoverOrphanConfig(this.serviceId).subscribe((errors) => {
        this.store.state.common.dryRunResults.set(this.serviceId, errors);
        if (!this.store.dryRunErrorsEqual(this.debugErrors, errors)) {
          this.debugErrors = errors;
        }
      });
    });
  }

  private fetchDebugErrors() {
    const cachedResults = this.store.state.common.dryRunResults.get(this.serviceId);
    if (cachedResults) {
      if (!this.store.dryRunErrorsEqual(this.debugErrors, cachedResults)) {
        this.debugErrors = cachedResults;
      }
    } else {
      this.serviceControllerService.recoverOrphanConfig(this.serviceId).subscribe((errors) => {
        this.store.state.common.dryRunResults.set(this.serviceId, errors);
        if (!this.store.dryRunErrorsEqual(this.debugErrors, errors)) {
          this.debugErrors = errors;
        }
      });
    }
  }

  public toggleActive() {
    this.form.active = !this.form.active;
    this.updateForm();
  }

  public updateForm(event?: any) {
    console.log(event);
    this.form.jsonDeterminants = this.tempDet;
    this.showDeterminant = false;
    this.saveForm.emit();
  }

  public notifyTabChange(newtab: string): void {
    this.activeTab = newtab;
  }

  public hasDeterminant(item) {
    if (!item.jsonDeterminants || item.jsonDeterminants === "[{\"type\":\"OR\",\"items\":[]}]" || (item.jsonDeterminants && JSON.stringify(item.jsonDeterminants) === "[{\"type\":\"OR\",\"items\":[]}]")) {
      return false;
    }
    return true;
  }

  public hasError(itemId: string): boolean {
    if (!this.debugErrors || !this.debugErrors.length || !itemId) { return false; }
    return this.debugErrors.some(error => error.componentKey === itemId);
  }

  public temoupdateDeterminant(eff) {
    this.tempDet = eff.jsonString;
  }

  public closeEditDeterminant() {
    this.store.state.common.determinantSection.topLayer = null;
    this.store.state.common.determinantSection.determinant = {};
  }

  public closeSection() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = null;
    this.style = {};
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public removeDeterminant() {
    this.form.jsonDeterminants = "";
    this.updateForm();
  }

  public openDetEdit() {
    this.store.state.common.sections.active = true;
    this.store.state.common.sections.type = "determinant";
  }

  public showModalHeader(e) {
    console.log(e);
    this.showDrawerHeader = e;
  }

}
